import { render, staticRenderFns } from "./ScoringProfilesEdit.vue?vue&type=template&id=75a9b2a9&scoped=true"
import script from "./ScoringProfilesEdit.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9b2a9",
  null
  
)

export default component.exports